'use strict';

import 'ui-cropper/compile/minified/ui-cropper';
import 'ui-cropper/compile/minified/ui-cropper.css';

import 'angular-ui-tree/dist/angular-ui-tree.min';
import 'angular-ui-tree/dist/angular-ui-tree.min.css';

import AdminDashboard from './dashboard/admin-dashboard.component';
import AdminPageList from './page/list/page-list.component';
import AdminPageEdit from './page/edit/page-edit.component';

import FrontpageSliderEditor from './frontpage-slider/frontpage-slider-editor.component';
import ContentSliderEditor from './content-slider/content-slider-editor.component';
import SliderEditor from './slider/slider-editor.component';
import SliderUploadComponent from '../../components/slider-upload/slider-upload.component';

import MenuEditor from './menu/menu-editor.component';
import DocumentTreeEditor from './document-tree/document-tree-editor.component';
import AppConfigEditor from './app-config/app-config.component';

import ActivationCodeSeedList from './activation-code/seed/seed-list.component';
import ActivationCodeList from './activation-code/list/code-list.component';
import ActivationCodeEdit from './activation-code/edit/code-edit.component';
import ActivationCodeService from '../../services/activation-codes/activation-code.service';

import ActivationCodeCreateComponent from '../../components/activation-code-create/activation-code-create.component';


export default angular.module('conduuApp.admin', ['uiCropper', AdminDashboard, AdminPageEdit, AdminPageList,
  SliderEditor, SliderUploadComponent, 'ui.tree', MenuEditor, AppConfigEditor, ActivationCodeSeedList,
  ActivationCodeList, ActivationCodeEdit, ActivationCodeService, ActivationCodeCreateComponent, DocumentTreeEditor,
  ContentSliderEditor, FrontpageSliderEditor])
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/index.js